import { createFileRoute, redirect } from '@tanstack/react-router';

/** Landing after sign-in: the first accessible reservoir, or the organization admin area. */
export const Route = createFileRoute('/_authed/')({
  beforeLoad: ({ context }) => {
    const { me } = context;
    const first = me.tenants[0];
    if (first) throw redirect({ to: '/t/$tenantSlug', params: { tenantSlug: first.slug } });
    throw redirect({ to: '/admin' });
  },
});
